module.exports = __webpack_public_path__ + "static/404-4e16aa40c9c1c24c14e8b81fe743e88b.svg";